<form [formGroup]="form">
  <div>
    <mat-form-field
      class="w-100"
      color="accent"
    >
      <mat-label>Source</mat-label>
      <mat-select
        id="source"
        formControlName="source"
        label="Source"
        placeholder="Source"
        required
      >
        <mat-option
          *ngFor="let item of items"
          [value]="item"
        >
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div
    *ngIf="[sourceStatus.Other, sourceStatus.Referral].includes(form.controls.source.value)"
  >
    <mojo-editor
      formControlName="sourceNote"
      [placeholder]="getSourceNotePlaceholder()"
      [material]="true"
      toolbar=""
      id="sourceNote"
    >
    </mojo-editor>
  </div>
</form>
